import { AlertTriangleIcon } from "lucide-react";
import { formatProblem, type ProblemDetails } from "@/lib/problemDetails";

interface ProblemDetailsAlertProps {
  problem: ProblemDetails | null | undefined;
  fallback?: string;
  className?: string;
}

export function ProblemDetailsAlert({
  problem,
  fallback,
  className,
}: ProblemDetailsAlertProps) {
  if (!problem) return null;
  const { title, detail, status } = formatProblem(problem, fallback);

  return (
    <div
      role="alert"
      className={
        "border-destructive/40 bg-destructive/5 text-destructive flex gap-3 rounded-md border p-3 text-sm" +
        (className ? ` ${className}` : "")
      }
    >
      <AlertTriangleIcon className="mt-0.5 size-4 shrink-0" />
      <div className="space-y-1">
        <p className="font-medium leading-snug">
          {title}
          {status ? (
            <span className="text-destructive/70 ml-2 font-mono text-xs">
              {status}
            </span>
          ) : null}
        </p>
        {detail && <p className="text-destructive/90 leading-snug">{detail}</p>}
      </div>
    </div>
  );
}
